import React from "react";

import { GoogleLogo } from "./googleLogo";
import { MicrosoftLogo } from "./microsoftLogo";

export interface ThirdPartyLogoParams {
  thirdParty: string;
}

export const ThirdPartyLogo: React.FC<ThirdPartyLogoParams> = ({
  thirdParty = "",
}) => {
  switch (thirdParty.toLocaleLowerCase()) {
    case "microsoft":
      return <MicrosoftLogo />;
    case "google":
      return <GoogleLogo />;
    default:
      return <></>;
  }
};
